"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
// Imported Api selectors
// getError: Get error string by key
// getErrorObj: Get original error object by key
// getPending: Get pending boolean by key
// getMeta: Get set request meta object by key
exports.default = radio_dispatch_1.selectors;
